import React from "react";

export default function Check({
  color = "#424242", width = "15", height = "11", ...restProps
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 19 15"
      {...restProps}
    >
      <g fillRule="evenodd">
        <path
          fill={color}
          d="M.508 8.27l6.975 6.204L19 2 17.61.723 7.387 11.798 1.838 6.885z"
        />
      </g>
    </svg>
  );
}
